import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Col,
  Container,
  Badge,
  Row,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import Loading from '../../shared/components/custom/Loading';
import Api from '../../util/api';
import { formatCurrencyNumber } from '../../util/functions';
import { partial } from '../../util/translation/translation';
import useConfig from '../../util/useConfig';
import { formatDateTime } from '../../util/date-and-time';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import useModal from '../../shared/hooks/useModal';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';

const TransactionsListPage = ({ entityId }) => {
  const config = useConfig();
  const [transactions, setTransactions] = useState([]);
  const [loadingTransactions, setLoadingTransactions] = useState(true);
  const [handleModal, visible, deleteObject] = useModal();
  const p = partial('transactions');
  const po = partial('paymentOptions');
  const s = partial('shared');

  const fetchTransactions = async () => {
    setLoadingTransactions(true);
    try {
      const resTransactions = await Api.transactions.getTransactions(entityId);
      setTransactions(resTransactions);
      setLoadingTransactions(false);
    } catch (err) {
      toast.error(p('transactionsRetrievingERROR'));
      setLoadingTransactions(false);
    }
  };
  useEffect(() => {
    fetchTransactions();
  }, []);

  const getBadgeColor = (status) => {
    switch (status) {
      case 'completed':
        return 'success';
      case 'pending':
        return 'warning';
      case 'failed':
        return 'danger';
      case 'refunded':
        return 'info';
      default:
        return 'default';
    }
  };
  const renderTransactions = () => {
    return transactions.map((transaction, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`transaction-${transaction.id}`}
      >
        {transaction.userId ? (
          <td>
            <Link to={`/users/edit/${transaction.userId}?tab=3`}>
              {transaction.userEmail}
            </Link>
          </td>
        ) : (
          <td>{transaction.userEmail}</td>
        )}
        <td>
          <Badge color={getBadgeColor(transaction.status)}>
            {p(`status-${transaction.status}`)}
          </Badge>
        </td>
        <td>
          {formatCurrencyNumber(Number(transaction.price) / 100)}{' '}
          {config.currencyCaps}
        </td>
        <td>
          <div className="flex-Vcenter">
            <Link
              to={`/payment-options/edit/${transaction.paymentOption.entityType}/${transaction.paymentOption.id}`}
            >
              {po(`providerType-${transaction.paymentOption.providerType}`)}
            </Link>
          </div>
        </td>
        <td>{formatDateTime(transaction.createdAt)}</td>
        <td>
          {transaction?.paymentOption?.paymentType === 'one_time' &&
            transaction.status === 'completed' && (
              <UncontrolledDropdown className="dashboard__table-more">
                <DropdownToggle>
                  <DotsHorizontalIcon />
                </DropdownToggle>
                <DropdownMenu className="dropdown__menu">
                  <DropdownItem
                    onClick={() =>
                      handleModal({
                        id: transaction.id,
                        type: transaction.paymentOption.entityType,
                      })
                    }
                    className="danger"
                  >
                    {p('refund')}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
        </td>
      </tr>
    ));
  };
  const refundTransaction = async () => {
    try {
      await Api.transactions.refundTransaction(deleteObject.id);
      handleModal(false);
      fetchTransactions();
    } catch (err) {
      toast.error(p('transactionsRetrievingERROR'));
    }
  };
  const getModalType = () => {
    if (!deleteObject) return '';
    switch (deleteObject.type) {
      case 'tier':
        return p('tier');
      default:
        return '';
    }
  };
  return (
    <Container>
      <Loading loading={loadingTransactions} />
      <DeleteModal
        visible={visible}
        modalType={'refund'}
        type={getModalType()}
        handleModal={handleModal}
        modalAction={refundTransaction}
      />
      <Row>
        <Col>
          <div
            style={{
              display: 'flex',
              paddingBottom: 5,
              background: '#fff',
              borderRadius: 6,
              border: '1px solid rgba(0,0,0,0.08)',
            }}
          >
            <Table responsive striped>
              <thead>
                <tr>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{s('email')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{s('status')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{po('price')}</div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">
                      {po('paymentOption')}
                    </div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">{s('date')}</div>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>{renderTransactions()}</tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TransactionsListPage;
